import React from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import classes from '../companyClusterFooter/companyClusterFooter.module.css';

const JobTitleClusterFooter = (props) => {
  const { linksData, TitleTagName, id } = props;
  return (
    <div id={id} className="row flex-column flex-md-row">
      {linksData.map(({ title, links }, index) => {
        if (!links?.length) return null;
        return (
          <div
            className={cn('col-12 col-lg-3', {
              'z-mt-48 z-mt-md-0': index > 0,
            })}
            key={title + index}
          >
            <TitleTagName className="text-capitalize open-sans-large-black-bold mb-4">
              {title}
            </TitleTagName>
            <ul className="m-0 p-0">
              {links.map(({ rel, link, text, title }, index) => (
                <li key={index} className={classes['footer-link-list-item']}>
                  <a className={classes['footer-link-list-item-link']} rel={rel} href={link} title={title}>
                    {text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

JobTitleClusterFooter.propTypes = {
  linksData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      links: PropTypes.array.isRequired,
    })
  ),
  totalColumnsInRow: PropTypes.number,
  TitleTagName: PropTypes.string,
};

JobTitleClusterFooter.defaultProps = {
  linksData: [],
  totalColumnsInRow: 4,
  TitleTagName: 'h3',
};

export default JobTitleClusterFooter;
